import React from 'react';

type Props = { children: React.ReactNode; fallback?: React.ReactNode };
type State = { hasError: boolean; error: any };

export class ChatErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, info: any) {
    // You can hook this up to your analytics/logging if desired
    // eslint-disable-next-line no-console
    console.error('[ChatErrorBoundary] Caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="p-3 text-sm text-red-700 bg-red-50 border-t-2 border-black">
            The chat widget failed to render.
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ChatErrorBoundary